export var NeutralColors;
(function (NeutralColors) {
    NeutralColors.black = '#000000';
    NeutralColors.gray220 = '#101010';
    NeutralColors.gray210 = '#151515';
    NeutralColors.gray200 = '#171717';
    NeutralColors.gray190 = '#1f1f1f';
    NeutralColors.gray180 = '#242424';
    NeutralColors.gray170 = '#282828';
    NeutralColors.gray160 = '#313131';
    NeutralColors.gray150 = '#3a3a3a';
    NeutralColors.gray140 = '#464646';
    NeutralColors.gray130 = '#646464';
    NeutralColors.gray120 = '#777777';
    NeutralColors.gray110 = '#888888';
    NeutralColors.gray100 = '#959595';
    NeutralColors.gray90 = '#9f9f9f';
    NeutralColors.gray80 = '#b1b1b1';
    NeutralColors.gray70 = '#bcbcbc';
    NeutralColors.gray60 = '#c6c6c6';
    NeutralColors.gray50 = '#d0d0d0';
    NeutralColors.gray40 = '#e5e5e5';
    NeutralColors.gray30 = '#ebebeb';
    NeutralColors.gray20 = '#f2f2f2';
    NeutralColors.gray10 = '#fafafa';
    NeutralColors.white = '#ffffff';
})(NeutralColors || (NeutralColors = {}));
export var DefaultThemeColors;
(function (DefaultThemeColors) {
    DefaultThemeColors.blue110 = '#00287F';
    DefaultThemeColors.blue100 = '#003C94';
    DefaultThemeColors.blue90 = '#0050A9';
    DefaultThemeColors.blue80 = '#0064BF';
    DefaultThemeColors.blue70 = '#0078D4';
    DefaultThemeColors.blue60 = '#258EDE';
    DefaultThemeColors.blue50 = '#49A3E7';
    DefaultThemeColors.blue40 = '#6EB9F1';
    DefaultThemeColors.blue30 = '#92CFFA';
    DefaultThemeColors.blue20 = '#D0E7F8';
    DefaultThemeColors.blue10 = '#F3F9FD';
})(DefaultThemeColors || (DefaultThemeColors = {}));
export var TextColors;
(function (TextColors) {
    TextColors.darkPrimary = NeutralColors.white;
    TextColors.lightPrimary = NeutralColors.gray200;
    TextColors.secondary = NeutralColors.gray130;
    TextColors.disabled = NeutralColors.gray60;
})(TextColors || (TextColors = {}));
export var HyperlinkColors;
(function (HyperlinkColors) {
    HyperlinkColors.hyperlink = DefaultThemeColors.blue80;
    HyperlinkColors.hyperlinkHoverPressed = DefaultThemeColors.blue100;
})(HyperlinkColors || (HyperlinkColors = {}));
export var SurfaceColors;
(function (SurfaceColors) {
    SurfaceColors.primary = NeutralColors.white;
    SurfaceColors.secondary = NeutralColors.gray10;
    SurfaceColors.tertiary = NeutralColors.gray20;
    SurfaceColors.quaternary = NeutralColors.gray30;
    SurfaceColors.navigation = NeutralColors.gray40;
})(SurfaceColors || (SurfaceColors = {}));
export var MessagingColors;
(function (MessagingColors) {
    MessagingColors.warning = '#fff4ce';
    MessagingColors.warningIcon = NeutralColors.gray130;
    MessagingColors.severeWarning = '#fed9cc';
    MessagingColors.severeWarningIcon = '#d73b02';
    MessagingColors.errorBlock = '#fde7e9';
    MessagingColors.errorBlockIcon = '#c5262c';
    MessagingColors.success = '#dff6dd';
    MessagingColors.successIcon = '#107c10';
    MessagingColors.defaultBackground = NeutralColors.gray20;
    MessagingColors.defaultIcon = NeutralColors.gray130;
})(MessagingColors || (MessagingColors = {}));
//# sourceMappingURL=CoherenceColors.js.map